import { IntlFormatters, MessageDescriptor } from 'react-intl';
import messages from './messages';

const registerRefererOptionsMap: { [key: string]: MessageDescriptor } = {
  ADVERTISEMENT: messages.registerReferrerOptionsADVERTISEMENT,
  ARTICLE: messages.registerReferrerOptionsARTICLE,
  CONVENTION: messages.registerReferrerOptionsCONVENTION,
  NEWSLETTER: messages.registerReferrerOptionsNEWSLETTER,
  OTHER: messages.registerReferrerOptionsOTHER,
  PAPER_CARD: messages.registerReferrerOptionsPAPER_CARD,
  PRODUCT_SELLER: messages.registerReferrerOptionsPRODUCT_SELLER,
  SOCIAL_NETWORKS: messages.registerReferrerOptionsSOCIAL_NETWORKS,
};

export function getFeedbackOptions(formatMessage: IntlFormatters['formatMessage']): { label: string; value: string }[] {
  return [
    { label: formatMessage(registerRefererOptionsMap['PRODUCT_SELLER']), value: 'PRODUCT_SELLER' },
    { label: formatMessage(registerRefererOptionsMap['PAPER_CARD']), value: 'PAPER_CARD' },
    { label: formatMessage(registerRefererOptionsMap['CONVENTION']), value: 'CONVENTION' },
    { label: formatMessage(registerRefererOptionsMap['ADVERTISEMENT']), value: 'ADVERTISEMENT' },
    { label: formatMessage(registerRefererOptionsMap['SOCIAL_NETWORKS']), value: 'SOCIAL_NETWORKS' },
    { label: formatMessage(registerRefererOptionsMap['NEWSLETTER']), value: 'NEWSLETTER' },
    { label: formatMessage(registerRefererOptionsMap['ARTICLE']), value: 'ARTICLE' },
    { label: formatMessage(registerRefererOptionsMap['OTHER']), value: 'OTHER' },
  ];
}
